import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone, X } from "lucide-react";
import { useSite } from "../lib/site";

const API = process.env.REACT_APP_BACKEND_URL;

export function SiteBanner() {
  const site = useSite();
  const [b, setB] = useState(null);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("banner-hidden") === "1");
  useEffect(() => { fetch(`${API}/api/marketing/public`).then((r) => r.json()).then((d) => setB(d.banner)).catch(() => {}); }, []);
  if (!b || !b.active || !b.text || hidden || (b.audience !== "all" && b.audience !== site)) return null;
  const tone = b.tone === "offer" ? "bg-success-strong text-white" : b.tone === "alert" ? "bg-warning text-foreground" : "bg-foreground text-white";
  const inner = <span className="inline-flex items-center gap-2"><Megaphone className="h-4 w-4" /> {b.text}</span>;
  return (
    <div className={`${tone} px-4 py-2 text-center text-sm font-medium`} data-testid="site-banner">
      {b.link ? (b.link.startsWith("/") ? <Link to={b.link} className="underline-offset-2 hover:underline">{inner}</Link> : <a href={b.link} className="hover:underline">{inner}</a>) : inner}
      <button onClick={() => { sessionStorage.setItem("banner-hidden", "1"); setHidden(true); }} className="ml-3 inline-flex align-middle opacity-70 hover:opacity-100" aria-label="Dismiss" data-testid="site-banner-close"><X className="h-4 w-4" /></button>
    </div>
  );
}
